import { render, staticRenderFns } from "./NotificationFollowings.vue?vue&type=template&id=61519772&scoped=true&"
import script from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
export * from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationFollowings.vue?vue&type=style&index=0&id=61519772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61519772",
  null
  
)

export default component.exports